import React,  { useState, useEffect } from 'react'

import {
    Form,
    Button,
    Row,
    Col,
    Dropdown
} from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'

import Message from '../Message/Message'

import Loader from '../Loader/Loader'

import FormContainer from '../FormContainer/FormContainer'

import { register } from '../../actions/stagiaireActions'

import Meta from '../Helmet/Meta'

import { listStagiaires } from '../../actions/stagiaireActions'

import './dashboard.css'

const StagiaireRegister = ({ location, history }) => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phonenumber, setPhonenumber] = useState('')
    const [formation, setFormation] = useState('')
    const [condition, setCondition] = useState('')

    const [message, setMessage] = useState(null)

    const dispatch = useDispatch()

    const  stagiaireRegister = useSelector(state => state.stagiaireRegister)


    const { stagiaireInfo } = stagiaireRegister

   // const redirect = location.search ? location.search.split('=')[1] : '/'


const stagiaireList = useSelector(state => state.stagiaireList)
const { loading, error, stagiaires } = stagiaireList


   // useEffect(() => {
   //     if (stagiaireInfo) {
   //         history.push("/")             
   //     }
   //      }, [stagiaireInfo, history])

useEffect(() => {
    if (stagiaireInfo) {
      dispatch(listStagiaires());
    }
  }, [dispatch, history, stagiaireInfo]);

//////////

    const submitHandler = (e) => {
        alert('Vous serez contacté dans les plus brefs délais ; Bienvenue');

        e.preventDefault()
        dispatch(register(name, email, phonenumber ,formation ,condition))

         // Rediriger vers la page principale après l'inscription réussie
         history.push('/');
    }

    return (
<div  className="main"  fluid >
        <FormContainer  className="main"  fluid >
            <Meta
                title=" | Register "
            />
             <br />
            <br /> <br />
            <br />
           
        

            <h1> Inscrivez-vous  </h1>
            {message && <Message variant='danger'>{message}</Message>}
            {error && <Message variant='danger'>{error}</Message>}
            {loading && <Loader />}
            <Form onSubmit={submitHandler}>
            <Row>
                    <Col md={5}>
                        <Form.Group controlId='name'>
                            <Form.Label> Nom et prénom <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="name"
                                value={name}
                                required
                                onChange={(e) => setName(e.target.value)}
                            ></Form.Control>
                        </Form.Group>

                        <Form.Group controlId='email'>
                            <Form.Label> Email  <span style={{ color: 'red' }}>*</span> </Form.Label>
                            <Form.Control
                                type="email"
                                value={email}
                                required
                                onChange={(e) => setEmail(e.target.value)}
                            ></Form.Control>
                        </Form.Group>

                        <Form.Group controlId='phonenumber'>
                            <Form.Label> Numéro de téléphone  <span style={{ color: 'red' }}>*</span> </Form.Label>
                            <Form.Control
                                type="phonenumber"
                                value={phonenumber}
                                required
                                onChange={(e) => setPhonenumber(e.target.value)}
                            ></Form.Control>
                        </Form.Group>
                    </Col>

                    <Col md={5}>
                                     
                   <div class="form-group">
                   <label for="selection"> Formation <span style={{ color: 'red' }}>*</span></label>
                   <select id="selection" class="form-control"    value={formation}
                                onChange={(e) => setFormation(e.target.value)}
                                required >
                     <option value="">Liste de choix...</option>
                     <option value="Intelligence Artificielle (IA)">Intelligence Artificielle (IA)</option>
                     <option value="Machine learning & Deep learning">Machine learning & Deep learning</option>
                      <option value="Learning">Learning </option>
                      <option value="Fintech">Fintech </option>
                      <option value="Big data">Big data </option>
                      <option value="Scrum/Agile"> Scrum/Agile</option>
                      <option value="Cloud computing"> Cloud computing </option>
                      <option value="Exploration de données"> Exploration de données </option>
                      <option value="Framework Spring"> Framework Spring </option>
                      <option value="Mobile software"> Mobile software </option>
                      <option value="Test de logiciel ISTQB"> Test de logiciel ISTQB </option>
                      </select>
                      </div>

                   <div class="form-group">
                   <label for="selection"> Condition <span style={{ color: 'red' }}>*</span></label>
                   <select id="selection" class="form-control"    value={condition}
                                onChange={(e) => setCondition(e.target.value)}
                                required >
                     <option value="">Liste de choix...</option>
                     <option value="À distance">À distance</option>
                     <option value="Sur site">Sur site</option>
                     <option value="À distance / Sur site">À distance / Sur site </option>
                     </select>
                      </div>

                        <Button type="submit"  style={{  backgroundColor: 'red'  }} >Inscription</Button>

                      
  
                    </Col>
                </Row>
                <br />
                <br />  <br />
            </Form>
            
        </FormContainer>
        </div>
    )
    }

export default StagiaireRegister
